import DeleteFolder from './DeleteFolder';

type ConfirmModalSubComponents = {
  DeleteFolder: typeof DeleteFolder;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteFolder = DeleteFolder;

export default ConfirmModal;
